<template>
  <div id="video" class="container-fluid px-0">
    <div class="main no-side-bar">
      <MainVideoWrapper/>
    </div>
  </div>
</template>

<script>
import Footer from "../components/Footer";
import MainVideoWrapper from '@/components/Video/MainVideoWrapper.vue'

export default {
  name: "Video",
  components: {
    MainVideoWrapper,
    Footer
  },
  data() {
    return {
      token: null
    };
  },
  mounted() {
   // this.token = this.$route.params.token;
  },
  methods: {

  }
};
</script>
<style lang="less">
#terms {
  font-size: 1.6rem;
  font-family: "FilsonProBook", sans-serif;
  .page-header {
    padding: 60px 0;
  }
  .page-title {
    text-align: left;
    h2 {
      text-align: left;
      font-size: 3.8rem;
      letter-spacing: 0.7rem;
      font-family: "FilsonProBold", sans-serif;
      color: #fff;
    }
  }
  .content-wrap {
    background: #f4f4f4;
    white-space: pre-wrap;
    .content-card {
      transform: translateY(-80px);
      background: #ffffff;
      max-width: 1000px;
      margin: auto;
      section {
        margin-bottom: 30px;
      }
      h4 {
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }
  }
  @media (max-width: 992px) {
    .page-header {
      padding-top: 100px;
    }
    .content-card {
      transform: translateY(0);
    }
  }
  p.brand-text {
    text-align: center;
    font-size: 1.6rem;
    font-weight: bold;
    max-width: 500px;
  }
}
</style>
